<template>
  <tr>
    <td>{{ user.Profile.Name }}</td>
    <td>{{ item.Content }}</td>
    <td>{{ item.Hours | dayFormat }}</td>
    <!-- 以下手機版不顯示 -->
    <!-- <td v-show="!isMobile">{{  }}</td> -->
    <td v-show="!isMobile">{{ item.Status }}</td>
    <!-- 以上手機版不顯示 -->
    <td>
      <v-btn
        class="ml-1 mr-1"
        color="white"
        text
        small
        @click.stop="view"
      >檢視</v-btn>

      <v-chip
        v-if="isSignEnabled"
        color="red"
        small
      >待審核</v-chip>
    </td>
  </tr>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import filterMixin from "@/data/filters/filter-mixin.vue";
export default {
  mixins: [filterMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    user() {
      return (
        this.users.find(o => o.ID == this.item.UserID) || { Profile: {} }
      );
    },
    userDepartmentID() {
      let vm = this
      const findUserDepartment = user => {
        let departmentID = (
          vm.$store.getters.userDepartments.find(o => o.UserID == user.ID) || {}
        ).DepartmentID;
        return departmentID;
      };
      return findUserDepartment(this.user)
    },
    isSignEnabled() {
      return (
        (this.item.Status == "審核中" &&
          this.myLevel == 10 &&
          this.userDepartmentID == this.myDepartment.ID) 
      );
    },
    ...mapGetters(["users", "me", "myLevel", "myDepartment"])
  },
  methods: {
    view() {
      let id = this.item.ID;
      this.$store.state.UI.dialog.compensatoryTimeDetail.id = id;
      this.$store.state.UI.dialog.compensatoryTimeDetail.isShow = true;
    }
  },
  filters: {
    dayFormat (hours) {
      return `${hours/8}天`
    }
  }
};
</script>